import { toTypedSchema } from "@vee-validate/zod"
import { useForm } from "vee-validate"
import z from "zod"
import type {
  TypedSchemaInput,
  TypedSchemaOutput,
} from "@/utils/typeUtilities"
import {
  requiredTrimmedString,
  trimmedString,
} from "@/forms/validation/stringFieldSchemas"

const cashierFormSchema = z.object({
  username: requiredTrimmedString(
    "Cashier name is required"
  ),
  color: trimmedString().nullable(),
  pin: z
    .string()
    .length(4, { message: "Pin must be 4 characters long" })
    .regex(/\d+/, {
      message: "Pin must only contain numeric characters",
    })
    .nullable(),
})

export type CashierFormInput = TypedSchemaInput<
  typeof cashierFormSchema
>
export type CashierFormOutput = TypedSchemaOutput<
  typeof cashierFormSchema
>

export const useCashierForm = () =>
  useForm({
    validationSchema: toTypedSchema(cashierFormSchema),
    initialValues: {
      username: "",
      color: null,
      pin: null,
    },
  })
